import Dexie from 'dexie';

const dbName = 'hanadb'

export const db = new Dexie(dbName);
db.version(1).stores({
  CachedImage: 'id, blob, size, timestamp', // image id <--> blob
  WorkReadMeta: '[workid+index], value'
});